const DEVICE_TYPES = ['DESKTOP', 'SMARTPHONE', 'TABLET', 'KIOSK'] as const

type DeviceType = typeof DEVICE_TYPES[number]

const BROWSER_TYPES = ['Chrome', 'Firefox', 'Safari', 'Opera', 'Other'] as const

type BrowserType = typeof BROWSER_TYPES[number]

export type DeviceInfoProps = {
  userAgent: string
  type: DeviceType
  browser: BrowserType
  ip: string
  dateTime: string
}

// O IP do usuario e preenchido pelo servico decathlon-search a partir dos
// cabecalhos da requisicao; nao consultamos mais servicos externos no cliente.
export async function getDeviceInfo(): Promise<DeviceInfoProps> {
  try {
    const ua = navigator.userAgent

    let type: DeviceInfoProps['type'] = 'DESKTOP'

    if (/mobile/i.test(ua)) {
      type = 'SMARTPHONE'
    } else if (/tablet|ipad|playbook|silk/i.test(ua)) {
      type = 'TABLET'
    }

    let browser: DeviceInfoProps['browser'] = 'Other'

    if (/chrome|crios|crmo/i.test(ua) && !/edge|edg\//i.test(ua)) {
      browser = 'Chrome'
    } else if (/firefox|fxios/i.test(ua)) {
      browser = 'Firefox'
    } else if (/safari/i.test(ua) && !/chrome|crios|crmo/i.test(ua)) {
      browser = 'Safari'
    } else if (/opera|opr\//i.test(ua)) {
      browser = 'Opera'
    }

    return {
      userAgent: ua,
      type,
      browser,
      ip: '',
      dateTime: new Date().toISOString(),
    }
  } catch (error) {
    console.error(error)

    return {
      userAgent: '',
      type: 'DESKTOP',
      browser: 'Other',
      ip: '',
      dateTime: new Date().toISOString(),
    }
  }
}
